// mall (qoo10 / rakuten / au-pay) ごとに振る舞いが変わる部分をここに集約する。
//
// application.jsx は本ファイルからのみ mall 固有 import / 関数を取得することで
// 3 ブランチ間で application.jsx 自体は同一に保たれ、ブランチ間 merge が容易になる。
//
// 本ファイルだけがブランチ間で差分を持つことになるので、ここを共通化しないこと。
//
// === rakuten 版 ===

import React from "react";
import { PriceSettingsSets } from "./price-setting/PriceSettingsSets";
import { AmazonCategory } from "./AmazonCategory";
import { RakutenAttributes } from "./RakutenAttributes";
import "./rakuten"; // side effect: .service-category クリック handler

// 価格自動設定 UI のコンポーネント
// rakuten では PriceSettingsSets を使用 (qoo10 / au-pay は PriceSettings)
export const MallPriceSettings = PriceSettingsSets;

// CSV ダウンロードフォーム準備時のフック。
// rakuten では trigger 要素の data-* 属性をすべて hidden input として form に投入する。
export const onCSVDownloadFormPrepared = (form, trigger) => {
    for (const key in trigger.dataset) {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = key;
        input.value = trigger.dataset[key];
        form.appendChild(input);
    }
};

// #bulk-price-setting-form の submit ハンドラ。
// rakuten では `.toggle-delete:checked` の value を id[] hidden として投入してから submit。
export const onBulkPriceSettingFormSubmit = (form, e) => {
    e.preventDefault();

    const selectedIds = Array.from(
        document.querySelectorAll('.toggle-delete:checked')
    ).map((cb) => cb.value);

    if (selectedIds.length === 0) {
        alert('商品を選択してください。');
        return false;
    }

    selectedIds.forEach((id) => {
        const input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'id[]';
        input.value = id;
        form.appendChild(input);
    });

    form.submit();
};

// onReady() の最後に呼ばれる mall 固有初期化。
// rakuten では .amazon-category クリック handler と .rakuten-attributes マウントを行う。
export const mallInit = ({ render }) => {
    document.querySelectorAll('.amazon-category').forEach((el) => {
        el.addEventListener('click', (e) => {
            e.preventDefault();
            const element = document.getElementById('amazon-category-dialog-root');
            if (!element) return false;
            const categories = JSON.parse(el.getAttribute('data-categories'));
            const onClose = () => {
                element.remove();
                const newEl = document.createElement('div');
                newEl.id = 'amazon-category-dialog-root';
                document.body.appendChild(newEl);
            };
            render(<AmazonCategory onClose={onClose} categories={categories} />, element);
            return false;
        });
    });

    document.querySelectorAll('.rakuten-attributes').forEach((div) => {
        const required = JSON.parse(div.getAttribute('data-required') || '[]');
        const rakuten_attributes = JSON.parse(div.getAttribute('data-rakuten-attributes') || '{}');
        const default_attributes = JSON.parse(div.getAttribute('data-rakuten-default-attributes') || '{}');
        const defined_attributes = JSON.parse(div.getAttribute('data-rakuten-defined-attributes') || '{}');
        render(
            <RakutenAttributes
                required={required}
                rakuten_attributes={rakuten_attributes}
                default_attributes={default_attributes}
                defined_attributes={defined_attributes}
            />,
            div,
        );
    });
};
